// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__Dsb6v","mobile":"sidebar_mobile__kjKeP","nav":"sidebar_nav__6CDu7","logo":"sidebar_logo__2hvhA","arrow":"sidebar_arrow__3CFVX"};